<template>

    <fragment >
      <text  :transform="indicator.transform" class="st1 st2" :class="[indicator.status == true ? activeClass :  desactiveClass,indicator.class ?indicator.class :'', isTVH ? 'small-text' : '' ]">
        {{indicator.text}}
      </text>
     <!--  <circle  :cx="indicator.cxB" :cy="indicator.cyB" :r="indicator.rB" :class="[indicator.status == true ? activeClass :  desactiveClass]"/>
      <circle   class="st0" :cx="indicator.cxW" :cy="indicator.cyW" :r="indicator.rW" :class="[indicator.status == true ? activeClass :  desactiveClass]"/> -->
      <line    class="st3 torreai" :x1="indicator.x1" :y1="indicator.y1" :x2="indicator.x2" :y2="indicator.y2" :class="[indicator.status == true ? activeClass :  desactiveClass,isTVH ? 'thin-line' : '']"/>
    </fragment>
   
   
   
   </template>
   <script>
   
   
   export default {
     name: "Indicators",
     data() {
       return{
         activeClass: 'aparece',
         desactiveClass: 'desaparece',
         textIndicator: ""
       }
     },
     props: {
        indicator: {
          type: Object,
          required: true,
        },
        isTVH: {
          type: Boolean,
          default: false, // Si no se pasa la prop, será `false` por defecto
        },
      },
     computed: {
     },
     methods: {
   
     },
     mounted() {
     
     }
   }
   </script>
<style scoped>
   .st3.torreai{
    stroke-width:2
   }
   /* Solo cuando isTVH es true, la línea tendrá un grosor de 1 */
.thin-line {
  stroke-width: 1  !important;
}

/* Solo cuando isTVH es true, el texto será pequeño */
.small-text {
  font-size: 1.5rem; /* Ajusta el tamaño del texto a lo que desees */
}
</style>